<textarea
  [formControl]="$any(formControl)"
  [readonly]="to.readonly"
  [rows]="to.rows"
  [formlyAttributes]="field"
  pInputTextarea
></textarea>
